Object.defineProperty (module.exports, "__esModule", { value: true });
module.exports.Orientation3D = module.exports.default = {
	AXIS_ANGLE: "axisAngle",
	EULER_ANGLES: "eulerAngles",
	QUATERNION: "quaternion"
};